import { DropdownList, DropdownListProps } from '@bob/library'
import { DataLayer } from '@websrc/App/Components/DataLayer'
import * as auth from '@websrc/App/Helpers/authManager'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { useEffect, useState } from 'react'

import * as SC from './MainTopbarAuth.style'

export interface IMainTopbarAuthProps {
  className?: string
  legoId: boolean
  showOnTop?: boolean
}

export const MainTopbarAuth = ({ className, legoId, showOnTop }: IMainTopbarAuthProps) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const locale = useLocale()
  const t = useStaticText()

  useEffect(() => {
    void auth.getUser().then((user) => {
      if (user) {
        setIsLoggedIn(true)
      }
    })
  }, [])

  if (!legoId) return null

  let links: DropdownListProps['links'] = [
    { title: t.account.log_in, onClick: () => void auth.signIn(locale) },
    { title: t.account.create_account, onClick: () => void auth.register(locale) },
  ]

  if (isLoggedIn) {
    links = [
      { title: t.account.edit_account, onClick: () => auth.edit(locale) },
      { title: t.account.log_out, onClick: () => void auth.signOut() },
    ]
  }

  return (
    <DataLayer.Set
      values={{
        login_status: isLoggedIn ? 'logged in' : 'not logged in',
      }}
    >
      <SC.StyledHoverMenu className={className} loggedIn={isLoggedIn} showOnTop={showOnTop}>
        <DropdownList links={links} />
      </SC.StyledHoverMenu>
    </DataLayer.Set>
  )
}
